<template>
  <div class="specialAdjustment">
    <el-table ref="tableData" :data="adjustmentList" border header-cell-class-name="headerStyle" cell-class-name="cellStyle">
      <el-table-column prop="versionNameSub" label="奖金版本"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="createUser" label="创建人"></el-table-column>
      <el-table-column label="上传状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.uploadState === 'Y' ? 'success' : 'danger'" disable-transitions>{{scope.row.uploadState==='Y'?'已上传':'未上传'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
      <el-table-column label="上传">
        <template slot-scope="scope">
          <el-upload :multiple='false'
          action
          :http-request="upload"
          :data={subVersionName:scope.row.versionNameSub,versionName:scope.row.versionName}
          :show-file-list='false'
          :before-upload="beforeUpload">
            <i class="el-icon-upload2 downloadIcon"></i>
          </el-upload>
        </template>
      </el-table-column>
      <el-table-column label="下载">
        <template slot-scope="scope">
          <i class="el-icon-download downloadIcon" @click="downloadFile(scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column label="附件上传">
        <template slot-scope="scope">
          <i class="el-icon-upload2 downloadIcon" @click="uploadTips" v-if="scope.row.uploadState!=='Y'"></i>
          <el-upload v-else
          :multiple='false'
          action
          :http-request="attachmentUpload"
          :data={mid:scope.row.id,relationIds:scope.row.relationIds,versionName:scope.row.versionName}
          :show-file-list='false'
          :before-upload="attachmentBeforeUpload">
            <i class="el-icon-upload2 downloadIcon"></i>
          </el-upload>
        </template>
      </el-table-column>
      <el-table-column label="附件下载">
        <template slot-scope="scope">
          <i class="el-icon-download downloadIcon" @click="attachmentDownload(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'specialAdjustment',
  data () {
    return {
      adjustmentList: []
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 特调列表
    getAdjustmentList (versionName) {
      // versionName--2020-医院渠道
      this.adjustmentList = []
      this.$http.get(this.API.specialAdjustmentList, { params: { versionName: versionName } }).then((res) => {
        let data = res.data
        this.adjustmentList = data.data
      })
    },
    // 上传前校验
    beforeUpload (file) {
      // console.log(file)
      // file.name-文件名字
      // file.size-文件大小
      // file.type-文件类型
      // 上传前格式与大小校验
      const isExcel = file.type === 'application/vnd.ms-excel' || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('上传文件只能是Excel格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传模板大小不能超过 2MB!')
      // }
      // return isJPG && isLt2M
      return isExcel
    },
    // 上传文件
    upload (e) {
      // console.log(e)
      let formData = new FormData()
      formData.append('subVersionName', e.data.subVersionName)
      formData.append('file', e.file)
      this.$http.post(this.API.specialAdjustmentUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          let data = res.data
          if (data.code === 200) {
            this.$message.success('上传成功！')
            this.getAdjustmentList(e.data.versionName)
          } else {
            this.$message.error(data.msg + ' --- 请重新上传！')
            this.getAdjustmentList(e.data.versionName)
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 下载文件
    downloadFile (row) {
      this.$http.get(this.API.specialAdjustmentDownload, { params: { subVersionName: row.versionNameSub }, responseType: 'blob' }).then(res => {
        // console.log(res)
        let data = res.data
        let responseType = data.type || null
        if (responseType.includes('application/json')) {
          let reader = new FileReader()
          reader.onload = (e) => {
            // console.log(e)
            let msg = JSON.parse(e.target.result).msg
            if (msg) {
              this.$message.error(msg)
            } else {
              this.$message.error('接口调用失败！')
            }
          }
          reader.readAsText(data)
        } else {
          let blob = new Blob([data], { type: data.type })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = row.versionNameSub + '.xls' // 下载后文件名
          document.body.appendChild(downloadElement) // 添加元素
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.$message.success('下载成功！')
        }
      })
    },
    // 附件上传前提示
    uploadTips () {
      this.$message.warning('请上传特调数据！')
    },
    // 附件上传前校验-PDF
    attachmentBeforeUpload (file) {
      // console.log(file)
      // file.name-文件名字
      // file.size-文件大小
      // file.type-文件类型
      // 上传前格式与大小校验
      const isExcel = file.type === 'application/pdf'
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('上传模板只能是PDF格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传模板大小不能超过 2MB!')
      // }
      // return isJPG && isLt2M
      return isExcel
    },
    // 附件上传
    attachmentUpload (e) {
      // console.log(e)
      let formData = new FormData()
      formData.append('mid', e.data.mid)
      formData.append('ids', e.data.relationIds)
      formData.append('file', e.file)
      this.$http.post(this.API.attachmentsUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        this.$message.success('附件上传成功！')
        this.getAdjustmentList(e.data.versionName)
      })
    },
    // 附件下载
    attachmentDownload (row) {
      if (row.attachmentState === 'Y') {
        let relationIds = row.relationIds.split(',')
        this.$http.get(this.API.attachmentsDownload, { params: { tid: row.id, id: relationIds[0] }, responseType: 'blob' }).then(res => {
        // console.log(res)
          let data = res.data
          let responseType = data.type || null
          if (responseType.includes('application/json')) {
            let reader = new FileReader()
            reader.onload = (e) => {
              // console.log(e)
              let msg = JSON.parse(e.target.result).msg
              if (msg) {
                this.$message.error(msg)
              } else {
                this.$message.error('接口调用失败！')
              }
            }
            reader.readAsText(data)
          } else {
            let blob = new Blob([data], { type: data.type })
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.href = href
            downloadElement.download = row.versionNameSub + '-' + '特调' + '.pdf' // 下载后文件名
            document.body.appendChild(downloadElement) // 添加元素
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href) // 释放掉blob对象
            this.$message.success('下载成功！')
          }
        })
      } else {
        this.$message.warning('请上传附件！')
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
